module.exports = __webpack_public_path__ + "static/img/KYLFDBgEng.57cafe9.png";


//////////////////
// WEBPACK FOOTER
// ./static/bg/KYLFDBgEng.png
// module id = JmqH
// module chunks = 1